import React, { Component } from 'react';
import {
  Button,
  Loader,
  Tab,
} from 'semantic-ui-react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export class PanePdf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      numPages: null,
      pageNumber: 1,
    }

    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    this.onNextPage = this.onNextPage.bind(this);
    this.onPreviousPage = this.onPreviousPage.bind(this);
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({ numPages });
  }

  onNextPage(e) {
    e.preventDefault();
    const { pageNumber, numPages } = this.state;

    if (pageNumber < numPages) {
      this.setState({ pageNumber: pageNumber + 1 });
    }
  }

  onPreviousPage(e) {
    e.preventDefault();
    const { pageNumber } = this.state;

    if (pageNumber > 1) {
      this.setState({ pageNumber: pageNumber - 1 });
    }
  }

  render() {
    const {
      baseUrl,
      pdfFilename,
    } = this.props;

    const {
      numPages,
      pageNumber,
    } = this.state;

    return (
      <Tab.Pane>
        <Document
          loading={<Loader active content="Loading PDF..." />}
          file={`/${baseUrl}/api/images/contract-pdf/${pdfFilename}`}
          onLoadSuccess={this.onDocumentLoadSuccess}
          renderMode="svg"
        >
          <Page scale={window.innerWidth <= 1024 ? 1.05 : 1.5} pageNumber={pageNumber} />
        </Document>
        <Button
          content="Previous"
          onClick={this.onPreviousPage}
          disabled={pageNumber === 1 ? true : false }
        />
        <Button
          content="Next"
          onClick={this.onNextPage}
          disabled={pageNumber === numPages ? true : false }
        />
        <Button
          primary
          content="Download"
          href={`/${baseUrl}/api/images/contract-pdf/${pdfFilename}`}
          download={`${pdfFilename}`}
        />
      </Tab.Pane>
    );
  }
}
